import React, { useEffect, useState, useCallback, useContext } from 'react';
import classNames from 'lib/classNames';
import styles from 'styles/charge_approval.module.scss'
import Modal from "./Modal"
import ShopContext from 'context/ShopContext';
import { trackMixPanelEvent } from "lib/mixpanel" 

const TallyModal = ({ }) => {
    const { AppLocalStorage, state: { id : shop} } = useContext(ShopContext)
    const [isModalVisible, setIsModalVisible] = useState(!AppLocalStorage.getItem('welcome_video_watched'));

    const close = () => {
        AppLocalStorage.setItem("welcome_video_watched", true);
        trackMixPanelEvent("First login", shop);
        setIsModalVisible(false);
    }

    return (
      <div className={classNames("absolute z-50")}>
        <Modal
          visible={isModalVisible}
          onClose={() => close()}
          style={{ minWidth: "900px", minHeight: "530px" }}
          background="bg-white"
        >
          {(close, setTitle) => (
            <div
              id="monster-upsell-cart"
              className={classNames("px-4 h-full w-full ")}
            >
              <div
                className={`${classNames("h-full w-full -mt-8")} ${
                  styles.navy_color
                }`}
              >
                <iframe
                  src="https://tally.so/embed/31kGaO?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
                  loading="lazy"
                  width="100%"
                  height="837"
                  frameborder="0"
                  marginheight="0"
                  marginwidth="0"
                  title="Welcome To Monster Cart Upsells"
                ></iframe>
              </div>
            </div>
          )}
        </Modal>
      </div>
    );

}

export default TallyModal;